//上海东方定制界面路由
export default [
  //介质列表(shdf)
  {
    path: "/:lang/Corp/SHDF/EBook/ApplicationJieZhiMain",
    name: "SHDFApplicationJieZhiMain",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebookBySHDF",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () =>
      import("/@/views/Corp/SHDF/EBook/ApplicationJieZhiMain.vue"),
  },
  //行业列表(shdf)
  {
    path: "/:lang/Corp/SHDF/EBook/ApplicationHangYeMain3",
    name: "SHDFApplicationHangYeMain3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () =>
      import("/@/views/Corp/SHDF/EBook/ApplicationHangYeMain.vue"),
  },
  // 行业系列列表(shdf)
  {
    path: "/:lang/Corp/SHDF/EBook/SeriesListHY3",
    name: "SHDFSeriesListHY3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/SHDF/EBook/SeriesListHY.vue"),
  },
  //介质选型（shdf）
  {
    path: "/:lang/XPump/SelSeriesListJZ3",
    name: "SelSeriesListJZ3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/SHDF/Select/SelSeriesListByJZ.vue"),
  },
  // 选型列表(行业-SHDF)
  {
    path: "/:lang/Corp/SHDF/Select/SeriesListHY3",
    name: "dfSelSeriesListHY3",
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/SHDF/Select/SelSeriesListByHY.vue"),
  },
];
